import { Controller, useFormContext } from 'react-hook-form'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ruRU } from '@mui/x-date-pickers/locales'
import dayjs, { Dayjs } from 'dayjs'
import { DatePicker } from 'ui'

type LkmAppealDateFieldProps = {
  setValidDate: (value: boolean) => void
  isValidDate: boolean
}

export function LkmAppealOfferDateField({
  setValidDate,
  isValidDate,
}: LkmAppealDateFieldProps) {
  const { control, setError, clearErrors } = useFormContext()

  const today = dayjs()
  const yearLatter = dayjs().add(1, 'year')

  const isAvailableDate = (value: Dayjs | null) => {
    if (!value || !value.isValid()) return false

    return value.isBetween(
      dayjs().startOf('day'),
      dayjs().add(1, 'year').endOf('day'),
      'day',
      '[]',
    )
  }

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale='ru'
      localeText={
        ruRU.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <Controller
        name='date'
        control={control}
        render={({ field: { onChange, value }, fieldState }) => (
          <DatePicker
            label='Предлагаемая дата'
            value={value ? dayjs(value) : null}
            minDate={today}
            maxDate={yearLatter}
            onChange={(newValue: Dayjs | null) => {
              if (!newValue || !newValue.isValid()) {
                onChange(null)
                setValidDate(false)
                setError('date', { type: 'manual' })
                return
              }

              if (!isAvailableDate(newValue)) {
                setValidDate(false)
                setError('date', { type: 'manual' })
                return
              }

              onChange(newValue.format('YYYY-MM-DD'))

              setValidDate(true)
              clearErrors('date')
            }}
            slotProps={{
              textField: {
                required: false,
                error: !!fieldState.error || !isValidDate,
                helperText:
                  fieldState.error?.message ||
                  (!isValidDate && 'Введите корректную дату'),
                inputProps: {
                  'data-testid': `lkm-offer-date`,
                },
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  )
}
